import React, { useEffect, useState, useRef, FC } from 'react';
import { useTheme } from '@mui/material/styles';
// Material UI core
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import StyledBox from 'views/rebranded-module/common/components/UI/BreadcrumbsV2/BreadcrumbsV2.styles';
import { Typography700 } from 'views/rebranded-module/common/components';

const BreadcrumbsV2:FC<any> = (props) => {
  const { data } = props;
  const theme = useTheme();
  const isLargeDown = useMediaQuery(theme.breakpoints.down('xl'));
  const [dir, setDir] = useState('right');
  const [showBcArrow, setShowBcArrow] = useState(
    data ? data.links?.length > 2 : true,
  );
  const breadcrumbsWrapper = useRef(null);
  const breadcrumbs = useRef(null);
  const breadcrumbsArrow = useRef(null);
  const GetBcScrollValue = () => {
    const outerWidth = breadcrumbsWrapper.current.offsetWidth;
    const scrollWidthElm = breadcrumbs.current.scrollWidth;
    const scrollingValue = scrollWidthElm - outerWidth;
    if (scrollingValue <= 0) {
      setShowBcArrow(false);
      breadcrumbs.current.style.paddingLeft = '0px';
      breadcrumbs.current.style.marginLeft = '0px';
    } else {
      setShowBcArrow(true);
      breadcrumbs.current.style.paddingLeft = theme.typography.pxToRem(55);
    }
    return scrollingValue;
  };
  const handleBcArrow = () => {
    // eslint-disable-next-line no-unused-expressions
    dir == 'right' ? setDir('left') : dir == 'left' && setDir('right');
    const scrollingValue = GetBcScrollValue();
    breadcrumbsArrow.current?.classList?.toggle('rotated');
    if (dir == 'right') {
      breadcrumbs.current.style.marginLeft = `${-scrollingValue}px`;
    }
    if (dir == 'left') {
      breadcrumbs.current.style.marginLeft = `${0}px`;
    }
  };

  const scrollToRightOnMobile = () => {
    isLargeDown && setDir('left');
    handleBcArrow();
  };

  useEffect(() => {
    GetBcScrollValue();
  });
  useEffect(() => {
    let refInterval;
    if (breadcrumbsArrow.current) {
      scrollToRightOnMobile();
    } else {
      refInterval = setInterval(() => {
        if (breadcrumbsArrow.current) {
          clearInterval(refInterval);
          scrollToRightOnMobile();
        }
      }, 300);
    }
    return () => clearInterval(refInterval);
  }, []);


  return (
    <StyledBox
      showBcArrow={showBcArrow}
      ref={breadcrumbsWrapper}
      >
      {isLargeDown && showBcArrow && (
        <Box className="BCNav" onClick={() => handleBcArrow()}>
          <KeyboardArrowRight ref={breadcrumbsArrow} className="BCArrow" />
        </Box>
      )}
      <List
        className="BCLinksCon"
        ref={breadcrumbs}
        itemScope
        itemType="https://schema.org/BreadcrumbList">
        {data.links.map((item, index) => (
          <ListItem
            className="BCListItem"
            key={`${item.text}`}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem">
            {item.path ? (
              <NavigatorLink
                className="BCLink"
                id={item?.id}
                href={item.path}
                itemProp="item"
                itemScope
                onClick={item.onClick}
                itemType="https://schema.org/Thing"
                translate={item.translate}
                itemID={
                  item.path.url
                    ? `${item.path.url}${index}`
                    : `${item.path}${index}`
                }>
                <Typography700
                  component="span"
                  variant="overline1"
                  itemProp="name"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              </NavigatorLink>
            ) : (
              <Typography700
                component="span"
                variant="overline1"
                itemProp="name"
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            )}
            <meta itemProp="position" content={index + 1} />
            {index + 1 !== data.links.length && (
              <Typography700
                  component="span"
                  variant="overline1"
                   px={0.5} 
                   >
                   \
               </Typography700>
            )}
          </ListItem>
        ))}
        {data.breadCrumbsTitle && (
          <ListItem
            className="BCListItem"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem">
            <Typography className="BCText" variant="h3" itemProp="name">
              {data.breadCrumbsTitle}
              <meta itemProp="position" content={data.links.length + 1} />
            </Typography>
          </ListItem>
        )}
      </List>
    </StyledBox>
  );
};
export { BreadcrumbsV2 };